import React, { useState, useEffect } from 'react';
import { Link,useLocation,useHistory} from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";



const LowerCapitalOutlays = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main">
                <div id="maintable" className='capital_outlay Common_warrent' style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav">
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>No margin call</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Why Trade Warrants?</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Lower capital outlay</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Releasing share capital</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                            {/*<link rel="stylesheet" href="css/common.css"/>*/}
                            <title>Lower Capital Outlay</title>
                            <style dangerouslySetInnerHTML={{__html: "\n            .contentbox table tbody td{\n               height:3em;\n               width:30%;\n               color:#000000;\n            }\n            .contentbox table tbody td.col1{\n                background-color: #FFF4D2;\n                text-align:left;\n                padding-left: 1em;\n            }\n            .contentbox table tbody td.col1{\n                padding-left: 1em;\n            }\n            .contentbox table tbody td.col2{\n                background-color: #FFFF80;\n                text-align:center;\n            }\n            .contentbox table tbody td.col3{\n                background-color: #FFD400;\n                text-align:center;\n            }\n            .contentbox table tfoot td.disclaimer{\n                padding-top: 0.5em;\n                color: #FFFFFF;\n                font-size: 0.8em;\n            }\n        " }} />
                            <div className="contentbox">
                                <p>Warrants enable investors to gain exposure to blue chip shares for a fraction of the share price.
                                An investor interested in purchasing shares who does not have immediate access to funds could 
                                purchase call warrants to capture the benefits of an anticipated price rise. Because of the 
                                significantly lower outlay for warrants, brokerage and transaction costs are also lower.</p>
                                <table className="ctable how-call-warrant">
                                <tbody>
                                    <tr>
                                    <td />
                                    <td className="col2 htxt">Shares</td>
                                    <td className="col3 htxt">Similar exposure through Warrants</td>
                                    </tr>
                                    <tr>
                                    <td className="col1 htxt">Cost</td>
                                    <td className="col2">MYR 50,000</td>
                                    <td className="col3">MYR 10,000</td>
                                    </tr>
                                    <tr>
                                    <td className="col1 htxt">Brokerage Cost*</td>
                                    <td className="col2">MYR 200</td>
                                    <td className="col3">MYR 40</td>
                                    </tr>
                                    <tr>
                                    <td className="col1 htxt">Stamp duty*</td>
                                    <td className="col2">MYR 50</td>
                                    <td className="col3">MYR 10</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                    <td className="disclaimer" colSpan={3}>
                                        *Assuming brokerage cost of 0.4% and stamp duty of 0.1%<br />
                                    </td>
                                    </tr>
                                </tfoot>
                                </table>
                                
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                   <div className='copyright_sec'>
                   Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                   </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >  <Link to="/edu/why-trade-warrant/releasing-share-capital">
                                                     
                                Releasing share capital
                                </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/why-trade-warrant/releasing-share-capital">
                            <div className="next right" />
                            </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/why-trade-warrant/no-margin-call"><div className="prev left" /></Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >  <Link to="/edu/why-trade-warrant/no-margin-call">
                                                     
                                	No margin call
                                    </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history}/>
            </div>

        </div>
      );
}
export default LowerCapitalOutlays;